import React from 'react';
import styles from './CustomizationTag.module.scss';

//common component to add customizations and its price
const CustomizationTag = ({ text,cost}) => {
  return (
   <div className={styles.customization_wrapper}>
    <div className={styles.customization_container}>
      <span className={`x-small ${styles.label}`}>Free engraving added:</span>
      <span className={`x-small bold ${styles.text}`}>{text}</span>
      {/* <span className={`x-small bold ${styles.cost}`}>${Math.trunc(cost)}</span> */}
    </div>
    </div>
  );
};

export default CustomizationTag;